import React from 'react';
import { useShop } from '../context/ShopContext';
import { X, Heart, ShoppingBag, Trash2, ArrowRight } from 'lucide-react';
import { formatINR } from '../data/products';
import { resolveProductImage, handleProductImageError } from '../utils/imageHelper';

export default function WishlistDrawer() {
  const {
    products,
    wishlist,
    toggleWishlist,
    addToCart,
    isWishlistOpen,
    setIsWishlistOpen
  } = useShop();

  const safeWishlist = Array.isArray(wishlist) ? wishlist : [];
  const safeProducts = Array.isArray(products) ? products : [];
  const wishlistedProducts = safeProducts.filter((p) => p && safeWishlist.includes(p.id));

  const handleMoveToBag = (product) => {
    if (!product) return;
    addToCart(product, 1);
    toggleWishlist(product.id);
  };

  return (
    <div 
      className={`drawer-backdrop ${isWishlistOpen ? 'active' : ''}`}
      onClick={() => setIsWishlistOpen(false)}
    >
      <div 
        className="drawer-panel"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '1.25rem 1.5rem',
          borderBottom: '1px solid var(--border-gold)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#0c0c14'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <Heart size={20} color="#f43f5e" fill="#f43f5e" />
            <h3 style={{ fontSize: '1.15rem', color: '#fff', fontWeight: 700 }}>
              Royal Wishlist ({safeWishlist.length})
            </h3>
          </div>
          <button
            className="btn-icon"
            onClick={() => setIsWishlistOpen(false)}
            style={{ width: '36px', height: '36px' }}
          >
            <X size={18} />
          </button>
        </div>

        {/* Item List */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}>
          {wishlistedProducts.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '4rem 1rem',
              color: 'var(--text-muted)'
            }}>
              <Heart size={48} color="#f43f5e" style={{ margin: '0 auto 1rem', opacity: 0.6 }} />
              <h4 style={{ color: '#fff', fontSize: '1.1rem', marginBottom: '0.4rem' }}>
                Your Wishlist is Empty
              </h4>
              <p style={{ fontSize: '0.85rem', marginBottom: '1.5rem' }}>
                Save your favorite bridal necklaces, solitaires and jewels here to review anytime.
              </p>
              <button 
                className="btn btn-gold btn-sm"
                onClick={() => setIsWishlistOpen(false)}
              >
                Explore Jewellery
              </button>
            </div>
          ) : (
            wishlistedProducts.map((prod) => {
              if (!prod) return null;
              const rawImg = (Array.isArray(prod.images) && prod.images[0]) || prod.image;
              const prodImg = resolveProductImage(rawImg, prod);
              return (
              <div
                key={prod.id}
                style={{
                  display: 'flex',
                  gap: '1rem',
                  padding: '1rem',
                  backgroundColor: '#151522',
                  borderRadius: 'var(--radius-sm)',
                  border: '1px solid var(--border-subtle)'
                }}
              >
                <img
                  src={prodImg}
                  alt={prod.name || 'Jewellery'}
                  onError={(e) => handleProductImageError(e, prod)}
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: 'var(--radius-sm)',
                    objectFit: 'cover',
                    flexShrink: 0,
                    background: '#12121c'
                  }}
                />

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '0.5rem'
                  }}>
                    <h4 style={{
                      fontSize: '0.88rem',
                      color: '#fff',
                      fontWeight: 600,
                      lineHeight: 1.3,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }} title={prod.name}>
                      {prod.name}
                    </h4>
                    <button
                      onClick={() => toggleWishlist(prod.id)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'var(--text-muted)',
                        cursor: 'pointer',
                        padding: '2px'
                      }}
                      title="Remove"
                    >
                      <Trash2 size={15} />
                    </button>
                  </div>

                  <div style={{
                    fontSize: '0.74rem',
                    color: 'var(--gold-400)',
                    margin: '0.2rem 0 0.5rem'
                  }}>
                    {prod.metal}
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '0.5rem'
                  }}>
                    <span style={{
                      fontSize: '1rem',
                      fontWeight: 700,
                      color: '#fff',
                      fontFamily: 'var(--font-serif)'
                    }}>
                      {formatINR(prod.price)}
                    </span>

                    <button
                      className="btn btn-gold btn-sm"
                      onClick={() => handleMoveToBag(prod)}
                      style={{
                        padding: '0.35rem 0.75rem',
                        fontSize: '0.75rem'
                      }}
                    >
                      <ShoppingBag size={13} /> Move to Bag
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
        </div>
      </div>
    </div>
  );
}
